export default __webpack_public_path__ + "static/media/manageFilesPerms.7cd22307.png";